var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-list-item-group"},[_c('div',{class:{
      'question-list-item-group__label': _vm.label,
      'question-list-item-group__label--bg-unset': _vm.labelBgNone,
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{class:{
    'question-list-item-group__value': true,
    'question-list-item-group__value--overflow-hidden': _vm.valueOverflowHidden,
  }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }